import React, { useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { NavLink } from 'react-router-dom';
import { HomeContext } from '../../Context/HomeContext';
import './Part3.css';
import { FaEye, FaRegCalendarAlt } from 'react-icons/fa';

const HeaderSlider = () => {
  const { homeData } = useContext(HomeContext);
  const sliderBlogs = homeData?.headerSliderBlogs || [];

  return (
    <div className="container py-4 position-relative">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation={{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop={true}
        spaceBetween={20}
        slidesPerView={1}
      >
        {sliderBlogs.map((blog) => (
          <SwiperSlide key={blog.id}>
            <NavLink to={`/blog/${blog.slug}`} className="text-decoration-none text-white">
              <div
                className="slider-card position-relative"
                style={{
                  backgroundImage: `url(https://api.funfillia.com/${blog.image_1150x900 || blog.image_850x500})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '550px',
                  borderRadius: '10px',
                }}
              >
                <div className="position-absolute bottom-0 start-0 bg-dark bg-opacity-50 text-white p-4 w-100">
                  <h3 className="fw-bold">{blog.title}</h3>
                  <small>
                  <FaRegCalendarAlt/> {new Date(blog.published_at).toLocaleDateString()} &nbsp;&nbsp; <FaEye/> {blog.views_count} views
                  </small>
                </div>
              </div>
            </NavLink>
          </SwiperSlide>
        ))}

        {/* Custom navigation buttons */}
        <div className="custom-prev">‹</div>
        <div className="custom-next">›</div>
      </Swiper>
    </div>
  );
};

export default HeaderSlider;
